import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import ExpiredMemberships from './components/expiredMemberships';
import DashboardQueries from './components/Queries';
import PendingPayments from './components/pendingPayments';
import EndingMemberships from './components/endingMemberships';
import { getDashboardData } from 'src/api';
import { CONSTANTS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';
import { membershipPlanReducerAction } from 'src/redux/reducers/membershipPlan';
import { batchesReducerAction } from 'src/redux/reducers/batches';
import { trainersReducerAction } from 'src/redux/reducers/trainer';
import { getMembershipPlan } from 'src/api/membership';
import { getTrainer } from 'src/api/trainer';
import { getBatch } from 'src/api/batches';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Dashboard = () => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user, gymId } = useSelector((state) => state.common);
  const [value, setValue] = useState(0);
  const { updateMembershipPlans } = membershipPlanReducerAction;
  const { updateBatches } = batchesReducerAction;
  const { updateTrainers } = trainersReducerAction;
  const [dashboardData, setDashboardData] = useState({
    expired_memberships: [],
    expiring_memberships: [],
    pending_payments: [],
    queries: []
  });

  useEffect(() => {
    dispatch(startLoading());
    getMembershipPlan(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          dispatch(updateMembershipPlans(res?.data?.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
    dispatch(startLoading());
    getBatch(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          dispatch(updateBatches(res.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
    dispatch(startLoading());
    getTrainer(user)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          dispatch(updateTrainers(res.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(startLoading());
    getDashboardData(user)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS)
          setDashboardData(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Helmet>
        <title>Dashboard | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          width: '100%',
          py: 3
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Queries" {...a11yProps(0)} />
            <Tab label="Pending Payments" {...a11yProps(1)} />
            <Tab label="Ending Memberships" {...a11yProps(2)} />
            <Tab label="Expired Memberships" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <DashboardQueries data={dashboardData.queries} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PendingPayments data={dashboardData.pending_payments} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <EndingMemberships data={dashboardData?.expiring_memberships} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ExpiredMemberships
            expired_memberships={dashboardData?.expired_memberships}
          />
        </TabPanel>
      </Box>
    </>
  );
};

export default Dashboard;
